const CheckboxUnControlled = ({ name, value, checked, disabled }) => {
  return (
    <div style={{ paddingTop: "5px", paddingBottom: "0" }}>
      {disabled ? (
        <label style={{ cursor: "not-allowed" }}>&nbsp;</label>
      ) : (
        <label>
          <input
            type="checkbox"
            name={name}
            value={value}
            defaultChecked={checked}
            disabled={disabled}
            style={{ cursor: "pointer" }}
          />
        </label>
      )}
    </div>
  );
};

export default CheckboxUnControlled;
